import ExcelJS from 'exceljs';
import type { AllocationListRow, ExportProgressHandler } from '../exportsPage.types';
import { buildAllocationListRows, downloadWorkbook, toMonthKey } from '../utils';
import { fetchAllocationExportItems } from './allocationsData';

const DATE_FORMAT = 'dd/mm/yyyy';

/** Monta a planilha detalhada, uma alocação por linha. */
function buildWorkbook(rows: AllocationListRow[]): ExcelJS.Workbook {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Alocações');

    worksheet.columns = [
        { header: 'Colaborador', key: 'collaboratorName', width: 36 },
        { header: 'Cliente', key: 'clientName', width: 32 },
        { header: 'Projeto', key: 'projectName', width: 32 },
        { header: 'Tipo de Escopo', key: 'scopeTypeLabel', width: 22 },
        { header: 'Data Início', key: 'startDate', width: 16 },
        { header: 'Data Fim', key: 'endDate', width: 16 },
    ];

    worksheet.getRow(1).font = { bold: true };

    rows.forEach((row) => {
        worksheet.addRow(row);
    });

    // Datas gravadas como Date para o Excel ordenar e filtrar como data
    worksheet.getColumn('startDate').numFmt = DATE_FORMAT;
    worksheet.getColumn('endDate').numFmt = DATE_FORMAT;

    worksheet.autoFilter = { from: 'A1', to: 'F1' };
    worksheet.views = [{ state: 'frozen', ySplit: 1 }];

    worksheet.getCell('A1').note = {
        texts: [
            {
                font: { size: 10, name: 'Calibri', family: 2 },
                text:
                    'Uma linha por alocação, incluindo todos os tipos de escopo.\n' +
                    'Data Fim vazia indica alocação sem término definido (vigente por prazo indeterminado).\n' +
                    'Alocações canceladas não entram na planilha.',
            },
        ],
        margins: { insetmode: 'custom', inset: [0.25, 0.25, 0.35, 0.35] },
    };

    return workbook;
}

/**
 * Exporta a listagem completa de alocações (colaborador, cliente, projeto,
 * tipo de escopo, início e fim). Retorna quantas linhas foram geradas.
 */
export async function exportAllocationsList(
    onProgress?: ExportProgressHandler
): Promise<number> {
    const items = await fetchAllocationExportItems(onProgress);
    const rows = buildAllocationListRows(items);
    const workbook = buildWorkbook(rows);

    await downloadWorkbook(workbook, `alocacoes-${toMonthKey(new Date())}.xlsx`);

    return rows.length;
}
